import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Youtube } from 'lucide-react';

const CARDS = [
  {
    id: 'linkedin',
    Icon: Linkedin,
    iconColor: '#0A66C2',
    title: 'LinkedIn Achievements',
    subtitle: 'Featured posts & milestones',
    testId: 'hof-card-linkedin',
  },
  {
    id: 'youtube',
    Icon: Youtube,
    iconColor: '#FF0000',
    title: 'YouTube Highlights',
    subtitle: 'Latest training videos & talks',
    testId: 'hof-card-youtube',
  },
];

export default function Blog() {
  return (
    <section id="blog" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-teal mb-4">
            — Achievements —
          </p>
          <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter">
            Hall of<br />Fame.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {CARDS.map((card, i) => (
            <motion.div
              key={card.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ delay: 0.08 * i, duration: 0.5 }}
              data-testid={card.testId}
              className="comic-panel glass rounded-2xl border-2 p-10 flex flex-col items-center justify-center text-center min-h-[280px] gap-5"
            >
              <div
                className="w-14 h-14 rounded-2xl flex items-center justify-center"
                style={{ background: `${card.iconColor}18`, border: `1px solid ${card.iconColor}30` }}
              >
                <card.Icon size={26} style={{ color: card.iconColor }} strokeWidth={1.75} />
              </div>

              <div className="flex flex-col gap-2">
                <h3 className="font-display font-bold text-xl text-white">
                  {card.title}
                </h3>
                <p className="font-mono text-[12px] text-white/50 tracking-wide">
                  {card.subtitle}
                </p>
              </div>

              <span className="inline-flex items-center px-3 py-1 rounded-full font-mono text-[10px] uppercase tracking-[0.2em] text-teal border border-teal/30 bg-teal/5">
                Coming Soon
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
